import React from "react";
import { site } from "../generated/content";
import "../style/Footer.css";

export default function Footer() {
  const { email, phoneText, phoneNumber, address, mapsUrl } = site.contact;

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__contact">
          <a href={`mailto:${email}`}>{email}</a>
          <a href={`tel:${phoneNumber}`}>{phoneText}</a>

          {/* The address becomes a map link only when a url is supplied;
              otherwise it stays plain text rather than a dead link. */}
          {address &&
            (mapsUrl ? (
              <a href={mapsUrl} target="_blank" rel="noopener noreferrer">
                {address}
              </a>
            ) : (
              <span className="footer__address">{address}</span>
            ))}
        </div>

        {/* Socials without a url are dropped during the content build, so a
            placeholder link never ships. */}
        {site.socials.length > 0 && (
          <div className="footer__socials">
            {site.socials.map((social) => (
              <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer">
                {social.name}
              </a>
            ))}
          </div>
        )}
      </div>
    </footer>
  );
}
